// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/merchandising/alcohol/v1/alcohol.proto (package stailer_service_specification.merchandising.alcohol.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/merchandising/alcohol/v1/alcohol.proto.
 */
const file_stailer_service_specification_merchandising_alcohol_v1_alcohol = /*@__PURE__*/
  fileDesc("CkRzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tZXJjaGFuZGlzaW5nL2FsY29ob2wvdjEvYWxjb2hvbC5wcm90bxI2c3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24ubWVyY2hhbmRpc2luZy5hbGNvaG9sLnYxIsgBCgdBbGNvaG9sErwBCillbmFibGVfZWRpdF9hbGNvaG9sX3NhbGVzX21hbmFnZW1lbnRfaW5mbxgBIAEoCEKIAZKCGVTphZLpoZ7osqnlo7LnrqHnkIbogIXmqJnorZjjgpLnrqHnkIbnlLvpnaLjgafnt6jpm4bjgafjgY3jgovjgYvjgpLmjIflrprjgZfjgb7jgZnjgIKqghkk6YWS6aGe6LKp5aOy566h55CG6ICF5qiZ6K2Y44Gu57eo6ZuGuIIZA8iCGQFiBnByb3RvMw", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.merchandising.alcohol.v1.Alcohol.
 * Use `create(AlcoholSchema)` to create a new message.
 */
const AlcoholSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_merchandising_alcohol_v1_alcohol, 0);


exports.file_stailer_service_specification_merchandising_alcohol_v1_alcohol = file_stailer_service_specification_merchandising_alcohol_v1_alcohol;
exports.AlcoholSchema = AlcoholSchema;
